import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Api from "../../Api";
import { LinkNewTagModalForm, ListTagDetail } from "../../component";

const TagDetail = () => {
   const { appTagId } = useParams();
  interface TagDetail {
    appTagId: number,
    tagId: number;
    tagName: string;
  }

  interface Tag {
    tagId: number,
    tagName: string
  }

  const initialState = {
    appTagId: Number(appTagId),
    tagId: null,
  };

  const [tagsRelationship, setAppTagsRelationship] = useState<TagDetail[]>([]);
  const [tagOptions, setTagOptions]=useState<Tag[]>([])
  const [findOptions, setFindOptions] = useState(initialState);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [listCount, setListCount] = useState(0);

  const api = Api();



  const fetchForDropdown = async () => {
    const response = await api.tag.getTags();
    setTagOptions([...response.tags])

  };

  const handleCreateTag = (payload: {tagIds: number[]}) => {
    api.appTag.createAppTagRelationship({...payload, appTagId}).then((response: any) => {
      toast.success(response.message);
      getTagsRelationships();
    });
  };

  const getTagsRelationships = () => {
    api.appTag.searchAppTagRelationship({...findOptions, pageIndex, pageSize}).then((response: any)=>{
      if(response){
        setAppTagsRelationship([...response.appTagRelationships]);
        setListCount(response.appTagRelationshipsCount);
        if(response.appTagRelationshipsPageIndex>1 && response.appTagRelationshipsPageSize === 0){
          setPageIndex(pageIndex-1)
        }
      }
    })
  };

  const resetFindOptions = () => setFindOptions({...initialState});

    const onChangePageIndex = (pageNumber: number) =>
      setPageIndex(pageNumber - 1);
    const onChangePageSize = (pageSize: number) => {setPageSize(pageSize); setPageIndex(0)}
    
    const handleFind = (findOptions: any) => setFindOptions(findOptions);
  
      const handelDelete = (appTagId: number, tagId: number) => {
        api.appTag.deleteAppTagRelationship({appTagId,tagId}).then((response: any)=>{
          if(response){
            toast.success(response.message);
            getTagsRelationships();
          }
        })
      };

  useEffect(() => {
    getTagsRelationships();
  }, [findOptions, pageIndex, pageSize]);

  useEffect(()=>{
    fetchForDropdown()
  },[]);

  return (
    <div className="w-100 p-2">
      <div className="float-end mx-2">
        <LinkNewTagModalForm
          onCreateNewTag={handleCreateTag}
          tagListForDropdown={tagOptions}
        />
      </div>

      <ListTagDetail 
      tagsList={tagsRelationship}
      resetFindOptions={resetFindOptions}
      findOptions={findOptions}
      tagListForDropdown={tagOptions}
      handleFind={handleFind}
      handelDelete={(appTagId: number,tagId: number ) =>
        handelDelete(appTagId, tagId, )
      }
      totalItemCount={listCount}
      pageIndex={pageIndex}
      pageSize={pageSize}
      onChangePageIndex={(pageNumber: number) =>
        onChangePageIndex(pageNumber)
      }
      onChangePageSize={onChangePageSize} />
    </div>
  );
};

export default TagDetail;
